<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="30rem"
  >
    <template v-slot:activator="{ on }">
      <v-row align="center" no-gutters>
        <v-btn small icon v-if="getWastes && getWastes.length > 0" v-on="on">
          <v-icon small>fa-drumstick-bite</v-icon>
        </v-btn>
        <v-btn small icon v-if="getOrders && getOrders.length > 0" v-on="on">
          <v-icon small>fa-truck-loading</v-icon>
        </v-btn>
        <v-btn
          small
          icon
          v-if="getCorrections && getCorrections.length > 0"
          v-on="on"
        >
          <v-fade-transition leave-absolute>
            <v-icon v-if="getRecentCorrection" small color="success"
              >fa-check</v-icon
            >
            <v-icon v-else small>fa-marker</v-icon>
          </v-fade-transition>
        </v-btn>
      </v-row>
    </template>
    <v-card>
      <v-card-title>
        <v-row align="center" justify="end" no-gutters>
          <v-btn icon @click="dialog = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-divider
        class="ma-2"
        v-if="getWastes && getWastes.length > 0"
      ></v-divider>
      <v-card-text v-if="getWastes && getWastes.length > 0">
        <v-row no-gutters align="center">
          <v-icon small left>fa-drumstick-bite</v-icon>
          <span class="title">Pertes récentes</span>
        </v-row>
        <v-row v-for="waste in getWastes" :key="waste.id">
          <v-col cols="6">
            <span class="subtitle-1">{{ waste.date | localFormat }}</span>
          </v-col>
          <v-col cols="4">
            <span class="subtitle-1">{{
              retrieveWasteCauseName(waste.waste_cause)
            }}</span>
          </v-col>
          <v-col cols="2" style="display: flex; justify-content: flex-end">
            <span class="subtitle-1">{{ Number(waste.quantity) }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider
        class="ma-2"
        v-if="getOrders && getOrders.length > 0"
      ></v-divider>
      <v-card-text v-if="getOrders && getOrders.length > 0">
        <v-row no-gutters align="center">
          <v-icon small left>fa-truck-loading</v-icon>
          <span class="title">Commandes en cours</span>
        </v-row>
        <v-row align="center" v-for="order in getOrders" :key="order.id">
          <v-col cols="8">
            <span class="subtitle-1">{{ order.created | localFormat }}</span>
          </v-col>
          <v-col cols="4" style="display: flex; justify-content: flex-end">
            <span class="subtitle-1">{{ Number(order.quantity_ordered) }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider
        class="ma-2"
        v-if="getCorrections && getCorrections.length > 0"
      ></v-divider>
      <v-card-text v-if="getCorrections && getCorrections.length > 0">
        <v-row no-gutters align="center">
          <v-icon small left>fa-marker</v-icon>
          <span class="title">Corrections récentes</span>
        </v-row>
        <v-row
          align="center"
          v-for="correction in getCorrections"
          :key="correction.id"
        >
          <v-col cols="8">
            <span class="subtitle-1">{{
              correction.created | localFormat
            }}</span>
          </v-col>
          <v-col cols="4" style="display: flex; justify-content: flex-end">
            <span class="subtitle-1">{{ Number(correction.quantity) }}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            :large="$vuetify.breakpoint.xsOnly"
            :block="$vuetify.breakpoint.xsOnly"
            @click="dialog = false"
          >
            Fermer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "InventoryGridInfosDialog",
  props: {
    item: {
      required: true
    }
  },
  computed: {
    ...mapGetters(["getInventoryRecords", "getWasteCauses"]),
    getWastes() {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === this.item.id
      );
      if (record) {
        return record.wastes;
      } else {
        return undefined;
      }
    },
    getOrders() {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === this.item.id
      );
      if (record) {
        return record.orders;
      } else {
        return undefined;
      }
    },
    getCorrections() {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === this.item.id
      );
      if (record) {
        return record.corrections;
      } else {
        return undefined;
      }
    },
    getRecentCorrection() {
      const record = this.getInventoryRecords.find(
        x => x.fk_product === this.item.id
      );
      if (record) {
        if (record.corrections.length > 0) {
          const sortedCorrs = [...record.corrections].sort((a, b) =>
            moment(b.created).diff(moment(a.created))
          );
          if (moment().diff(sortedCorrs[0].created, "m") < 2) {
            return true;
          }
        }
      }
      return false;
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    retrieveWasteCauseName(id) {
      const wc = this.getWasteCauses.find(x => x.id === id);
      return wc ? wc.name : "";
    }
  }
};
</script>

<style></style>
